import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fi from "./locales/fi.json";
import sv from "./locales/sv.json";
import en from "./locales/en.json";

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources:{
    fi:{ translation: fi },
    sv:{ translation: sv },
    en:{ translation: en }
  },
  fallbackLng:"fi", // Dafault language Finnish
  detection:{
    order:["localStorage", "navigator", "htmlTag"],
    caches:["localStorage"],
  },
  interpolation:{
    escapeValue:false
  }
});

export default i18n;